import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import ConfirmationModal from './ConfirmationModal';
import $ from 'jquery';
import editImg from "../../src/components/images/icon-edit.svg";
import delImg from "../../src/components/images/delete.svg";
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import { Row, Col } from 'react-bootstrap';
import '../components/FetchData.css';
import Switch from "react-switch";
import { Redirect } from "react-router-dom";
import { TimeOutNotification } from './TimeOutNotification';

export class SiteManagement extends Component {
    static displayName = SiteManagement.name;

    constructor(props) {
        super(props);
        this.state = {
            forecasts: [], loading: true, show: false, SiteId: '', MsBirConsented: false, SiteIdLinkedWithUser: false, SiteIdEdit: '', InstitutionNameEdit: '', MsbirConsentEdit: '', updateCheckbox: true,
            expireMins: 0,
            sesExpNotMins: 0,
            marginTop: "-200px",
        };
        this.getAllSiteIds = this.getAllSiteIds.bind(this);
        this.CheckSiteIdlinkedWithUser = this.CheckSiteIdlinkedWithUser.bind(this);
        this.AddSiteId = this.AddSiteId.bind(this);
        this.CancelSite = this.CancelSite.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.confirmUpdate = this.confirmUpdate.bind(this);
        this.updateSiteId = this.updateSiteId.bind(this);
        this.startSessionTimeoutCounter = this.startSessionTimeoutCounter.bind(this);
    }

    componentDidMount() {
       
        window.addEventListener('mousemove', this.handleActivity);
        window.addEventListener('keydown', this.handleActivity);
        window.addEventListener('scroll', this.handleActivity);
        this.getAllSiteIds();
    }

    componentWillUnmount() {
        window.removeEventListener('mousemove', this.handleActivity);
        window.removeEventListener('keydown', this.handleActivity);
        window.removeEventListener('scroll', this.handleActivity);
    }
    handleActivity = () => {
        window['resetCountersOnEvent'](this.state.expireMins, this.state.sesExpNotMins);
    };

    startSessionTimeoutCounter() {
        this.setState({
            expireMins: parseInt(window.localStorage.getItem('ExpireMinutes')),
            sesExpNotMins: parseInt(window.localStorage.getItem('SessionExpireNotificationMinutes'))
        });
        window['startNotificationCounter'](this.state.expireMins, this.state.sesExpNotMins);
    }
    updateSiteId(siteId, msbirConsented, institutionName) {
        this.setState({
            show: true,
            SiteIdEdit: siteId,
            MsbirConsentEdit: msbirConsented,
            InstitutionNameEdit: institutionName,
            modalName: 'updateConfirmModal',
            updateCheckbox: false,
        });
    }

    handleClose() {
        this.setState({
            show: false
        }, () =>
            console.log(this.state));
    }

    deleteSiteId(id) {
        this.CheckSiteIdlinkedWithUser(id);
    }
    confirmUpdate() {
        var id = this.state.SiteIdEdit;
        var msbirConsented = this.state.MsbirConsentEdit;
        var institutionName = this.state.InstitutionNameEdit;
        $.ajax({
            url: '/SiteManagement/UpsertSite',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            data: {
                siteId: id,
                isMsbirConsented: msbirConsented,
                institutionName: institutionName
            },
            success: function (data) {
                $("#content").hide();
                $("#InstitutionName").val("");
                this.setState({
                    forecasts: data, loading: false, updateCheckbox: true
                });
            }.bind(this)
        });
    }
    confirmDelete() {
        $.ajax({
            url: '/SiteManagement/DeleteSite',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            data: {
                siteId: this.state.SiteIdEdit,
            },
            success: function (data) {
                $("#content").hide();
                $("#InstitutionName").val("");
                this.setState({
                    forecasts: data, loading: false
                });
            }.bind(this)
        });
    }

    render() {
        return (
            <div>

                <Button variant="primary" onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    $('#content').toggle();
                }}>Add New Site</Button>
                <div id="content" style={{ background: "white", display: "none", height: "265px", width: "100%" }}>
                    <div style={{ background: "#133245", height: "45px", width: "100%" }}>
                    </div>
                    <Form>
                        <br />
                        <Container>

                            <Row>

                                <Col md={2}><Form.Label>Institution Name</Form.Label></Col>
                                <Col md={4}><Form.Control type="text" id="InstitutionName" style={{ height: "38px", width: "80%" }} /></Col>

                            </Row>
                            <Row>

                                <Col md={2}><Form.Label>MSBIR Consented</Form.Label></Col>
                                <Col md={4}><BootstrapSwitchButton id="MsbirConsent" type="checkbox" size="sm" onChange={(checked: boolean) => {
                                    this.setState({ MsBirConsented: checked })
                                }} /></Col>

                            </Row>
                            <Row>
                                <Col md={2}></Col>
                                <Col md={4}><table><tbody><tr><td><Button variant="secondary" id="cancelSite" onClick={this.CancelSite}>Cancel</Button></td>
                                    <td width="12px"></td><td><Button variant="primary" id="addSiteId" onClick={this.AddSiteId}>Add</Button></td></tr></tbody></table></Col>
                            </Row>
                        </Container>
                    </Form>
                </div>
                <div>

                    <table className='table table-striped' aria-labelledby="tabelLabel" style={{ width: "100%" }}>
                        <thead style={{ backgroundColor: "#1861ac" }}>
                            <tr>
                                <th>Institution Name</th>
                                <th>MSBIR Consented</th>
                                <th>Update</th>
                                <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.forecasts.map((item, idx) =>
                                <tr key={item.id}>
                                    <td><input type="text" defaultValue={item.institutionName} id={'name' + idx} style={{ height: "38px", width: "70%" }} /></td>
                                    <td><Switch
                                        id={'msbir' + idx}
                                        onChange={(e) => this.handleMsBaseChange(e, idx)}
                                        checked={item.msbirConsented}
                                        onColor='#50b4e2'
                                        offColor='#D3D3D3'
                                        uncheckedIcon={
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    height: "100%",
                                                    fontSize: 15,
                                                    color: "black",
                                                    paddingRight: 2
                                                }}
                                            >
                                                No
                                            </div>
                                        }

                                        checkedIcon={
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    height: "100%",
                                                    fontSize: 15,
                                                    color: "white",
                                                    paddingRight: 2
                                                }}
                                            >
                                                Yes
                                            </div>
                                        }
                                    /></td >
                                    <td>
                                        <Button variant="primary" onClick={(e) => this.updateSiteId(item.id, item.msbirConsented, $('#name' + idx).val())}>
                                            <img src={editImg} alt="" />
                                        </Button>{' '}
                                    </td>
                                    <td>
                                        <Button variant="primary" value={item.id} onClick={(e) => this.deleteSiteId(item.id)}>
                                            <img src={delImg} alt="" />

                                        </Button>{' '}
                                    </td>

                                </tr>

                            )}
                        </tbody>
                    </table>

                </div>
                <ConfirmationModal
                    stateProps={this.state}
                    handleClose={this.handleClose}
                    confirmDelete={this.confirmDelete}
                    confirmUpdate={this.confirmUpdate}
                />
                <TimeOutNotification
                    sessionState={this.state}

                />
            </div>

        );
    }

    CheckSiteIdlinkedWithUser(siteId) {
        $.ajax({
            url: '/SiteManagement/GetUsersLinkedWithSite',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            data: { siteId: siteId },
            success: function (data) {
                this.setState({ SiteIdLinkedWithUser: data.length > 0 }, () => {
                    if (!this.state.SiteIdLinkedWithUser) {
                        this.setState({
                            show: true,
                            SiteIdEdit: siteId,
                            modalName: 'deletConfirmModal'
                        }, () =>
                            console.log(this.state));
                    }
                    else {
                        alert("Unable to remove Site ID as user(s) " + JSON.stringify(data) + " are linked to this Site ID")
                    }
                }
                )
            }.bind(this)
        });
    }
    async getAllSiteIds() {
        await this.setState({
            loading: false
        }, () =>
            console.log(this.state));

        $.ajax({
            url: '/SiteManagement/GetAllSites',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            success: function (data) {
                $("#content").hide();
                $("#InstitutionName").val("");

                this.setState({
                    forecasts: data, loading: false
                });
                this.startSessionTimeoutCounter();
               
            }.bind(this)
        });
    }

    async AddSiteId() {
        await this.setState({
            loading: false
        }, () =>
            console.log(this.state));
        var institutionName = $("#InstitutionName").val();

        $.ajax({
            url: '/SiteManagement/UpsertSite',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            data: {
                siteId: null,
                isMsbirConsented: this.state.MsBirConsented,
                institutionName: institutionName
            },
            success: function (data) {
                $("#content").hide();
                $("#InstitutionName").val("");
                this.setState({
                    forecasts: data, loading: false
                });
            }.bind(this)
        }).fail(function (jqXhr, TextStatus, ErrorThrown) {
            console.log(jqXhr);
            console.log(TextStatus, "\n", ErrorThrown);
            Redirect("/Areas/Identity/Pages/Account/AccessDenied");
        });
    }
    async CancelSite() {
        $("#content").hide();
    }
    async handleMsBaseChange(checked, index) {
        let forecasts = [...this.state.forecasts];
        forecasts[index].msbirConsented = checked;
        this.setState({ forecasts })
    }
}